import { z } from 'zod/v4';

/**
 * Ticket status enum values
 */
export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'] as const;
export type TicketStatus = (typeof TICKET_STATUSES)[number];

/**
 * Support ticket filters schema
 */
export const supportTicketFiltersSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(20),
  status: z.enum(TICKET_STATUSES).optional(),
  userId: z.coerce.number().optional(),
  assignedAdminId: z.coerce.number().optional(),
  search: z.string().optional(),
  sortBy: z.enum(['id', 'createdAt', 'status', 'resolvedAt', 'question']).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type SupportTicketFiltersDto = z.infer<typeof supportTicketFiltersSchema>;

// Терпимо принимаем статус в любом регистре — admin-bulk-actions исторически
// шлют lowercase ('closed'), а UI селектор — uppercase ('CLOSED'). Чтобы не
// разваливаться на 400 из-за регистра, нормализуем до enum.
const ticketStatusInputSchema = z.preprocess(
  (v) => (typeof v === 'string' ? v.toUpperCase() : v),
  z.enum(TICKET_STATUSES),
);

/**
 * Update ticket schema
 */
export const updateTicketSchema = z.object({
  status: ticketStatusInputSchema.optional(),
  assignedAdminId: z.number().nullable().optional(),
});

export type UpdateTicketDto = z.infer<typeof updateTicketSchema>;

/**
 * Reply to ticket schema
 */
export const replyToTicketSchema = z.object({
  message: z.string().min(1, 'Сообщение не может быть пустым').max(4000, 'Сообщение слишком длинное'),
});

export type ReplyToTicketDto = z.infer<typeof replyToTicketSchema>;
